const SubscriptionStatus = {
    INACTIVE: 0,
    ACTIVE: 1,
};

export default SubscriptionStatus;
